import Vue from "vue";
import router from "@/router";
import store from "@/store";
import i18n from "@/locales/i18n";
import httpRequest from "@/utils/httpRequest";

// 默认国家为全球
export const defaultCountry = "WW";

export function checkMessageInfo(msg) {
  return `${msg}`;
}

/**
 * 获取uuid
 */
export function getUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    return (c === "x" ? (Math.random() * 16) | 0 : "r&0x3" | "0x8").toString(
      16
    );
  });
}

/**
 * 是否有权限
 * @param {*} key
 */
export function isAuth(key) {
  return router.authorities.indexOf(key) >= 0;
}
export function checkMessage(msg) {
  return `${msg}`;
}
window.isAuth = isAuth;

/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate(data, id = "id", pid = "parentId") {
  var res = [];
  var temp = {};
  for (var i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i];
  }
  for (var k = 0; k < data.length; k++) {
    if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
      if (!temp[data[k][pid]]["children"]) {
        temp[data[k][pid]]["children"] = [];
      }
      if (!temp[data[k][pid]]["_level"]) {
        temp[data[k][pid]]["_level"] = 1;
      }
      data[k]["_level"] = temp[data[k][pid]]._level + 1;
      temp[data[k][pid]]["children"].push(data[k]);
    } else {
      res.push(data[k]);
    }
  }
  return res;
}

/**
 * 将数组中的parentId列表取出，倒序排列
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function idList(
  data,
  val,
  id = "id",
  children = "children",
  getName = false
) {
  let res = [];
  idListFromTree(data, val, res, id, children, getName);
  return res;
}

/**
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
function idListFromTree(
  data,
  val,
  res = [],
  id = "id",
  children = "children",
  getName = false
) {
  for (let i = 0; i < data.length; i++) {
    const element = data[i];
    if (element[children]) {
      if (idListFromTree(element[children], val, res, id, children, getName)) {
        res.push(
          getName
            ? { id: element[id], name: element.categoryName }
            : element[id]
        );
        return true;
      }
    }
    if (element[id] === val) {
      res.push(
        getName ? { id: element[id], name: element.categoryName } : element[id]
      );
      return true;
    }
  }
}

/**
 * 清除登录信息
 */
export function clearLoginInfo() {
  Vue.cookie.delete("Authorization_vp");
  store.commit("resetStore");
  store.commit("user/updateIsDouyinQudao", false);
  router.options.isAddDynamicMenuRoutes = false;
  localStorage.removeItem("navUserId");
  localStorage.removeItem("navCache");
}

export function getNavUserId() {
  if (localStorage.getItem("navUserId")) {
    return Number(localStorage.getItem("navUserId"));
  }
  return 0;
}

/**
 * 保存分页状态（当前页码、每页条数），用于页面刷新后保持分页
 * @param {string} key 存储键
 * @param {object} page { currentPage, pageSize }
 */
export function savePageState(key, page) {
  if (!key || !page) return;
  localStorage.setItem(
    key,
    JSON.stringify({
      currentPage: page.currentPage || 1,
      pageSize: page.pageSize || 10,
    })
  );
}

/**
 * 读取分页状态（当前页码、每页条数）
 * @param {string} key 存储键
 * @returns {{currentPage: number, pageSize: number} | null}
 */
export function getPageState(key) {
  if (!key) return null;
  const item = localStorage.getItem(key);
  if (!item) return null;
  try {
    const page = JSON.parse(item);
    if (
      page &&
      typeof page.currentPage === "number" &&
      typeof page.pageSize === "number"
    ) {
      return page;
    }
  } catch (e) {
    // 忽略解析异常
  }
  return null;
}

export function saveNavCache(data) {
  data.expires = Date.now() + 1000 * 60 * 60; //expire in 1 hour
  localStorage.setItem("navCache", JSON.stringify(data));
  localStorage.setItem("navUserId", data.userInfo.userId);
  const code =
    localStorage.getItem("storageDistCountryCode") ||
    store.state.user.distCountryCode;
  const key = Object.keys(localStorage).find(
    (key) => key === `${data.userInfo.userId}${code}trolleyCarFiamp`
  );
  if (!key) {
    localStorage.setItem(
      `${data.userInfo.userId}${code}trolleyCarFiamp`,
      JSON.stringify([])
    );
  } else {
    const objectList = JSON.parse(
      localStorage.getItem(`${data.userInfo.userId}${code}trolleyCarFiamp`)
    );
    localStorage.setItem(
      `${data.userInfo.userId}${code}trolleyCarFiamp`,
      JSON.stringify(objectList)
    );
  }
}

export function getNavCache() {
  let cacheData = localStorage.getItem("navCache");
  if (!cacheData) {
    return null;
  }

  let data = JSON.parse(cacheData);

  if (data && data.expires > Date.now()) {
    return data;
  } else {
    console.log("nav cache has expired");
    return null;
  }
}

export function getCurrencyZhName(currency) {
  return i18n.t("mainCurrency." + currency);
}

export function getCurrencySymbol(currency) {
  switch (currency) {
    case "USD":
      return "$";
    case "CNY":
      return "￥";
    case "SGD":
      return "S$";
    case "HKD":
      return "HK$";
    case "PHP":
      return "₱";
    case "MYR":
      return "RM";
    case "GBP":
      return "£";
    case "CAD":
      return "C$";
    case "KRW":
      return "₩";
    case "JPY":
      return "¥";
    default:
      return currency;
  }
}

export function getCountryZhName(countryCode) {
  return i18n.t("countryList." + countryCode);
}

export function getPayTypeName(payType) {
  if (isNull(payType)) {
    return i18n.t("order.none");
  }

  return i18n.t("payType.payType" + payType);
}

export function formatTm(dt, formatStr) {
  var str = formatStr;
  var Week = ["日", "一", "二", "三", "四", "五", "六"];

  str = str.replace(/yyyy|YYYY/, dt.getFullYear());
  str = str.replace(
    /yy|YY/,
    dt.getYear() % 100 > 9
      ? (dt.getYear() % 100).toString()
      : "0" + (dt.getYear() % 100)
  );

  var mon = dt.getMonth() + 1;
  str = str.replace(/MM/, mon > 9 ? mon.toString() : "0" + mon);
  str = str.replace(/M/g, mon);

  str = str.replace(/w|W/g, Week[dt.getDay()]);

  str = str.replace(
    /dd|DD/,
    dt.getDate() > 9 ? dt.getDate().toString() : "0" + dt.getDate()
  );
  str = str.replace(/d|D/g, dt.getDate());

  str = str.replace(
    /hh|HH/,
    dt.getHours() > 9 ? dt.getHours().toString() : "0" + dt.getHours()
  );
  str = str.replace(/h|H/g, dt.getHours());
  str = str.replace(
    /mm/,
    dt.getMinutes() > 9 ? dt.getMinutes().toString() : "0" + dt.getMinutes()
  );
  str = str.replace(/m/g, dt.getMinutes());

  str = str.replace(
    /ss|SS/,
    dt.getSeconds() > 9 ? dt.getSeconds().toString() : "0" + dt.getSeconds()
  );
  str = str.replace(/s|S/g, dt.getSeconds());

  var millisec = dt.getMilliseconds().toString();
  if (millisec < 10) {
    millisec = "00" + millisec;
  } else if (millisec < 100) {
    millisec = "0" + millisec;
  } else millisec = millisec.toString();

  str = str.replace(/fff|FFF/, millisec);

  return str;
}

export function download(data, fileName, blobType) {
  var blob = new Blob([data], { type: blobType });

  const elink = document.createElement("a");
  if ("download" in elink) {
    // 非IE下载
    elink.download = fileName;
    elink.style.display = "none";
    elink.href = URL.createObjectURL(blob);
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href); // 释放URL 对象
    document.body.removeChild(elink);
  } else {
    // IE10+下载
    navigator.msSaveBlob(blob, fileName);
  }
}

export function isNull(obj) {
  return (
    (!obj &&
      typeof obj != "undefined" &&
      obj != 0 &&
      obj != false &&
      obj != "") ||
    typeof obj == "undefined"
  );
}

Date.prototype.format = function (formatStr) {
  var str = formatStr;
  var Week = ["日", "一", "二", "三", "四", "五", "六"];

  str = str.replace(/yyyy|YYYY/, this.getFullYear());
  str = str.replace(
    /yy|YY/,
    this.getYear() % 100 > 9
      ? (this.getYear() % 100).toString()
      : "0" + (this.getYear() % 100)
  );

  var mon = this.getMonth() + 1;
  str = str.replace(/MM/, mon > 9 ? mon.toString() : "0" + mon);
  str = str.replace(/M/g, mon);

  str = str.replace(/w|W/g, Week[this.getDay()]);

  str = str.replace(
    /dd|DD/,
    this.getDate() > 9 ? this.getDate().toString() : "0" + this.getDate()
  );
  str = str.replace(/d|D/g, this.getDate());

  str = str.replace(
    /hh|HH/,
    this.getHours() > 9 ? this.getHours().toString() : "0" + this.getHours()
  );
  str = str.replace(/h|H/g, this.getHours());
  str = str.replace(
    /mm/,
    this.getMinutes() > 9
      ? this.getMinutes().toString()
      : "0" + this.getMinutes()
  );
  str = str.replace(/m/g, this.getMinutes());

  str = str.replace(
    /ss|SS/,
    this.getSeconds() > 9
      ? this.getSeconds().toString()
      : "0" + this.getSeconds()
  );
  str = str.replace(/s|S/g, this.getSeconds());

  var millisec = this.getMilliseconds().toString();
  if (millisec < 10) {
    millisec = "00" + millisec;
  } else if (millisec < 100) {
    millisec = "0" + millisec;
  } else millisec = millisec.toString();

  str = str.replace(/fff|FFF/, millisec);

  return str;
};

Date.prototype.add = function (strInterval, Number) {
  var dtTmp = this;
  switch (strInterval) {
    case "f":
      return new Date(dtTmp.getTime() + Number);
    case "s":
      return new Date(dtTmp.getTime() + 1000 * Number);
    case "n":
      return new Date(dtTmp.getTime() + 60000 * Number);
    case "h":
      return new Date(dtTmp.getTime() + 3600000 * Number);
    case "d":
      return new Date(dtTmp.getTime() + 86400000 * Number);
    case "w":
      return new Date(dtTmp.getTime() + 86400000 * 7 * Number);
    case "q":
      return new Date(
        dtTmp.getFullYear(),
        dtTmp.getMonth() + Number * 3,
        dtTmp.getDate(),
        dtTmp.getHours(),
        dtTmp.getMinutes(),
        dtTmp.getSeconds()
      );
    case "m":
      return new Date(
        dtTmp.getFullYear(),
        dtTmp.getMonth() + Number,
        dtTmp.getDate(),
        dtTmp.getHours(),
        dtTmp.getMinutes(),
        dtTmp.getSeconds()
      );
    case "y":
      return new Date(
        dtTmp.getFullYear() + Number,
        dtTmp.getMonth(),
        dtTmp.getDate(),
        dtTmp.getHours(),
        dtTmp.getMinutes(),
        dtTmp.getSeconds()
      );
  }
};
// 独立站登录、未登录使用独立站返回国家，非独立站登录后使用登录账号的国家，未登录为默认
export const getCountryCode = async ({ $route, $store, $cookie }) => {
  // console.log("getCountryCode");
  const { independentData: independentDataStore } = $store.state.common;

  let countryCode = defaultCountry;
  // 独立站接口已请求有缓存
  let independentData;
  if (Object.keys(independentDataStore).length > 0) {
    independentData = independentDataStore;
  } else {
    // 未请求
    independentData = await $store.dispatch("common/independentStationData");
  }
  if (
    independentData &&
    !independentData.flag &&
    Object.keys(independentData).length > 0
  ) {
    // 独立站
    countryCode = independentData.countryCode;
  } else {
    // 非独立站
    // 登录状态
    if ($cookie.get("Authorization_vp")) {
      const { data } = await getCurrentCountry();
      countryCode = data;
    } else {
      // 未登录
      // 路由有 country
      const { country } = $route.query;
      if (country) {
        countryCode = country;
      } else {
        // 如果有本地缓存使用本地缓存
        const country = window.localStorage.getItem("countryCode");
        if (country) {
          countryCode = country;
        }
      }
    }
  }

  return countryCode;
};
export const getCurrentCountry = () => {
  return httpRequest({
    url: httpRequest.adornUrl("/platform/partner/home/getCurrentCountry"),
    method: "GET",
  });
};

// 处理价格千分位
export const formatPrice = (num) => {
  if (num === null || num === undefined) return "";
  const numStr = num.toString();
  const [integer, decimal] = numStr.split(".");

  // 处理整数部分（添加千位分隔符）
  const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // 处理小数部分（如果有）
  return decimal ? `${formattedInteger}.${decimal}` : formattedInteger;
};

// 返回当前需要对应的域名
export const host = () => {
  let hostVal = window.location.host;
  if (process.env.NODE_ENV == "production") {
    hostVal = "portalapi.luckseller.com";
  }

  return hostVal;
};

export function getQueryParams() {
  const url = window.location.href;
  const queryString = url ? url.split("?")[1] : window.location.search.slice(1);
  const params = new URLSearchParams(queryString);
  return params;
}
